import { watch } from 'vue'

// 舵机片段参数联动（servos / dualServos 通用）：
// 1. 上一个片段的结束角度变化 -> 自动同步为下一个片段的开始角度
// 2. （可选）下一个片段的开始角度变化 -> 反向同步为上一个片段的结束角度
// 3. 开始/结束角度变化 -> 自动重置 1/3、2/3 点为直线插值（还原过程中跳过）
// 参数：
//   listRef            - 舵机数组 Ref（每项含 m: [{ steps, param: [start, end, y1/3, y2/3] }]）
//   isRestoring        - 还原中标记 Ref（可空），为 true 时跳过插值重置
//   syncStartToPrevEnd - 是否启用第 2 条反向同步（目前仅单舵机 servos 启用）
export function useMotionParamSync(listRef, { isRestoring = null, syncStartToPrevEnd = false } = {}) {
  // 结束角度 -> 下一个片段的开始角度
  watch(
    () => listRef.value.map(servo => servo.m.map(m => m && m.steps !== undefined ? m.param[1] : null)),
    () => {
      listRef.value.forEach(servo => {
        servo.m.forEach((motion, mIdx) => {
          if (!motion || motion.steps === undefined) return
          if (servo.m[mIdx + 1] && servo.m[mIdx + 1].steps !== undefined) {
            const endVal = Number(motion.param[1])
            if (!isNaN(endVal)) {
              servo.m[mIdx + 1].param[0] = Number(endVal.toFixed(1))
            }
          }
        })
      })
    },
    { deep: true }
  )

  if (syncStartToPrevEnd) {
    // 开始角度 -> 上一个片段的结束角度
    watch(
      () => listRef.value.map(servo => servo.m.map(m => m && m.steps !== undefined ? m.param[0] : null)),
      () => {
        listRef.value.forEach(servo => {
          servo.m.forEach((motion, mIdx) => {
            if (!motion || motion.steps === undefined) return
            if (servo.m[mIdx - 1] && servo.m[mIdx - 1].steps !== undefined) {
              const startVal = Number(motion.param[0])
              if (!isNaN(startVal)) {
                servo.m[mIdx - 1].param[1] = Number(startVal.toFixed(1))
              }
            }
          })
        })
      },
      { deep: true }
    )
  }

  // 开始/结束角度变化 -> 重置 1/3、2/3 点为直线插值
  watch(
    () => listRef.value.map(servo => servo.m.map(m => m && m.steps !== undefined ? [m.param[0], m.param[1]] : null)),
    (newVals, oldVals) => {
      if (isRestoring && isRestoring.value) return
      newVals.forEach((servoArr, sIdx) => {
        servoArr.forEach((pair, mIdx) => {
          if (!pair) return
          const [newStart, newEnd] = pair
          const [oldStart, oldEnd] = oldVals?.[sIdx]?.[mIdx] || []
          if (newStart !== oldStart || newEnd !== oldEnd) {
            const motion = listRef.value[sIdx].m[mIdx]
            if (motion && motion.steps !== undefined) {
              const startNum = Number(newStart)
              const endNum = Number(newEnd)
              if (!isNaN(startNum) && !isNaN(endNum)) {
                motion.param[2] = Number((startNum + (endNum - startNum) / 3).toFixed(1))
                motion.param[3] = Number((startNum + 2 * (endNum - startNum) / 3).toFixed(1))
              }
            }
          }
        })
      })
    },
    { deep: true }
  )
}
